import React, { useState, useContext } from "react";
import _ from "lodash";
import { Popover, Chip, TextField } from "@material-ui/core";
import { RequestContext } from "../../context/RequestContext";
import AddIcon from "@material-ui/icons/Add";
import { usePopperStyles } from "./Popper.styles";

export default function EmailPopper({ mode, data, keyRef, source, setSource, anchor, onClose, readOnly }) {
  const classes = usePopperStyles();
  const { contacts, _setContacts } = useContext(RequestContext);
  const [value, setValue] = useState("");
  const [error, setError] = useState(null);

  const handleKeyDown = (e) => {
    if (["Enter", "Tab", ",", "click"].includes(e.key)) {
      e.preventDefault();
      if (value && isValid(value)) {
        if (mode === "delivery") {
          setSource({ ...source, [keyRef]: [...data, value] });
        } else {
          _setContacts([...contacts, value]);
        }
        setValue("");
        setError(null);
      }
    }
  };
  const isValid = (email) => {
    let errorMessage = null;

    if (isInList(email)) {
      errorMessage = `${email} has already been added.`;
    }

    if (!isEmail(email)) {
      errorMessage = `${email} is not a valid email address.`;
    }

    if (errorMessage) {
      setError(errorMessage);
      return false;
    }

    return true;
  };
  const isInList = (email) => {
    return mode === "delivery" ? _.includes(data, email) : _.includes(contacts, email);
  };

  const isEmail = (email) => {
    //eslint-disable-next-line
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
  };

  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValue(e.target.value);
    setError(null);
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text");
    //eslint-disable-next-line
    const emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);
    if (emails) {
      const toBeAdded = emails.filter((email) => !isInList(email));

      if (mode === "delivery") {
        setSource({ ...source, [keyRef]: [...data, toBeAdded] });
      } else {
        _setContacts([...contacts, ...toBeAdded]);
      }
    }
  };

  const handleClose = () => {
    onClose();
  };

  const open = Boolean(anchor);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Popover
        id={"email_popper" + id}
        open={open}
        anchorEl={anchor}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}>
        <>
          <div>
            {_.map(mode === "delivery" ? data : contacts, (option, index) => {
              return (
                <li
                  style={{
                    listStyleType: "none",
                    marginLeft: "10px",
                    marginTop: "5px",
                    marginRight: "5px",
                  }}
                  key={index}>
                  <Chip
                    label={option}
                    key={index}
                    style={{
                      marginTop: "5px",
                      marginBottom: "5px",
                      overflow: "auto",
                    }}
                    onDelete={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setError(null);
                      if (mode === "delivery") {
                        let deleteVal = data.filter((entry) => entry !== option);
                        setSource({ ...source, [keyRef]: deleteVal });
                      } else {
                        _setContacts(contacts.filter((entry) => entry !== option));
                      }
                    }}
                  />
                </li>
              );
            })}
          </div>
          {readOnly ? null : (
            <TextField
              error={Boolean(error)}
              value={value}
              placeholder="Type/paste email address"
              onKeyDown={handleKeyDown}
              size="small"
              InputProps={{
                endAdornment: (
                  <AddIcon
                    color="primary"
                    onClick={() => {
                      if (value && isValid(value)) {
                        if (mode === "delivery") {
                          setSource({ ...source, [keyRef]: [...data, value] });
                        } else {
                          _setContacts([...contacts, value]);
                        }
                        setValue("");
                        setError(null);
                      }
                    }}
                  />
                ),
                // classes: {
                //   adornedEnd: classes.adornedEnd,
                // },
              }}
              className={classes.input}
              inputProps={{ classes: { root: classes.inputProp } }}
              variant="outlined"
              onChange={handleChange}
              onPaste={handlePaste}
              helperText={error}
            />
          )}
        </>
      </Popover>
    </div>
  );
}

EmailPopper.defaultProps = {
  anchor: null,
  readOnly: false,
  mode: "request",
  onClose: () => {},
  data: [],
  setSource: () => {},
  keyRef: "",
  source: {},
};
